<template>
  <div class="card product-card">
    <div v-if="products.length" class="product-list-card-body">
      <div>
        <div class="row header-row">
          <div class="col-3">
            <h6 class="header">Product</h6>
          </div>
          <div class="col-2 text-center">
            <h6 class="header">Qty</h6>
          </div>
          <div class="col-2 text-center">
            <h6 class="header">Price</h6>
          </div>
          <div class="col-2 text-center">
            <h6 class="header">Tax</h6>
          </div>
          <div class="col-2 text-end">
            <h6 class="header">Amount</h6>
          </div>
          <div class="col-1 text-end">
            <h6 class="header"></h6>
          </div>
        </div>
        <template v-for="(product, index) in products" :key="index">
          <div :class="[isOdd(index + 1) ? 'striped' : null, 'row value-row']">
            <div class="col-3 values">
              {{ product.name }}
            </div>
            <div class="col-2 text-center values">
              {{ product.quantity }}
              <span v-if="product.purchaseType === productPurchaseTypes.monthly">× 12</span>
            </div>
            <div class="col-2 text-center values">
              {{ $filters.formatPrice(product.price, "USD") }}
            </div>
            <div class="col-2 text-center values">{{ product.tax ?? 0 }} %</div>
            <div class="col-2 text-end values">
              <span v-if="product.purchaseType === productPurchaseTypes.monthly">
                {{
                  $filters.formatPrice(
                    product.price * product.quantity * 12 * (1 + (product.tax || 0) / 100),
                    "USD"
                  )
                }}
              </span>
              <span v-else>
                {{
                  $filters.formatPrice(
                    product.price * product.quantity * (1 + (product.tax || 0) / 100),
                    "USD"
                  )
                }}
              </span>
            </div>
            <div class="col-1 text-end values">
              <div class="product-actions">
                <Icon
                  icon="mdi:pencil-outline"
                  class="edit-icon"
                  @click="$emit('edit-product', product, index)"
                />
                <Icon
                  icon="mdi:trash-can-outline"
                  class="delete-icon"
                  @click="$emit('remove-product', index)"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="empty-products-state">
      <TableEmptyState text="No products added" />
    </div>
  </div>
</template>

<script>
import { Icon, TableEmptyState } from "@/components/ui";
import { ProductPurchaseTypes } from "@/utils/enums";

export default {
  name: "OpportunityProductsCard",
  components: {
    Icon,
    TableEmptyState,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      productPurchaseTypes: ProductPurchaseTypes,
    };
  },
  methods: {
    isOdd(number) {
      return number % 2 !== 0;
    },
  },
};
</script>

<style scoped>
.product-card {
  border-radius: 10px;
  border: none;
  margin: 8px 10px 0 10px;
  background-color: #ffffff;
}

.product-card .product-list-card-body {
  max-height: 150px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 8px;
  padding-bottom: 8px;
}

.header-row {
  padding-top: 2px;
  padding-bottom: 2px;
  border-bottom: 1px solid #e5e7eb;
}

.product-card .header {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7280;
}

.product-card .values {
  font-size: 10px;
  font-weight: 400;
  color: #6b7280;
}

.product-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}

.edit-icon {
  font-size: 16px;
  color: #2d60ff;
  cursor: pointer;
  transition: color 0.2s ease;
}

.edit-icon:hover {
  color: #1e4dcc;
}

.delete-icon {
  font-size: 16px;
  color: #dc3545;
  cursor: pointer;
  transition: color 0.2s ease;
}

.delete-icon:hover {
  color: #c82333;
}

.product-card .value-row {
  padding-top: 6px;
  padding-bottom: 6px;
}

.product-card .striped {
  background-color: #f9fafb;
}

.empty-products-state {
  padding: 30px 20px;
  min-height: 150px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
